<template>
  <div class="inquiry">
    <el-tooltip effect="dark" :content="isSearching?'取消搜索':'搜索'" placement="top">
      <svg-icon v-if="!isSearching" icon-class="Search" className="icon-search" @click="openSearcher"/>
      <svg-icon v-else icon-class="CancelSearch" className="icon-search" @click="cancelSearch"/>
    </el-tooltip>
    <el-row>
    <el-col :span="24">
    <el-card shadow="always" body-style="text-align:center;padding:0px;" id='tableCard'>
      <el-table :data="items" header-align="center" size="small" highlight-current-row :cell-style="{padding:'5px',fontSize:'13px',borderColor:'#ddd'}" ref="multipleTable" height='calc(100vh - 75px)' border stripe :header-cell-style="headerStyle" :row-style="{height:'45px'}">
        <el-table-column prop="SN" label="物料号" align="center" width="70"></el-table-column>
        <el-table-column prop="Name" label="名称" min-width="75" align="center"></el-table-column>
        <el-table-column prop="Description" label="规格描述" min-width="170" align="left"></el-table-column>
        <el-table-column prop="Brand" label="品牌" min-width="75" align="center"></el-table-column>
        <el-table-column prop="Quantity" label="数量" min-width="80" align="center" :formatter="calcQuantity"></el-table-column>
        <el-table-column label="单价" align="center" width="125">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.Inquiry" :key="index" :class="item.isSelect?'item-selected':'item-not-selected'">{{ item.Currency=='CNY'?item.UnitPrice.toLocaleString('zh-CN', { style: 'currency', currency:'CNY' }):item.UnitPrice.toLocaleString('en-US', { style: 'currency', currency:'USD' }) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="货期(周)" align="center" width="70">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.Inquiry" :key="index" :class="item.isSelect?'item-selected':'item-not-selected'">{{ item.DeliveryTime }}</div>
          </template>
        </el-table-column>
        <el-table-column label="供应商" align="center" width="170">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.Inquiry" :key="index" :class="item.isSelect?'item-selected':'item-not-selected'">{{ calcSupplier(item.Supplier) }}</div>
          </template>
        </el-table-column>
        <el-table-column label="询价日期" align="center" width="90">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.Inquiry" :key="index" :class="item.isSelect?'item-selected':'item-not-selected'">{{ calcDate(item.Date) }}</div>  
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" min-width="100">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.Inquiry" :key="index" :class="item.isSelect?'item-selected':'item-not-selected'">{{ item.Remark }}</div>  
          </template>
        </el-table-column>
        <el-table-column label="负责人" width="80" align="center" :formatter="calcPIC"></el-table-column>
        <el-table-column label="审批状态" width="80" align="center" v-if="PIC==user_id">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.Record.length&&scope.row.Record[0].Status==1" size="small" type="primary">待审批</el-tag>
            <el-tag v-if="scope.row.Record.length&&scope.row.Record[0].Status==2" size="small" type="success">已同意</el-tag>
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">{{ scope.row.Record.length&&scope.row.Record[0].Comment}}</div>
              <el-tag v-if="scope.row.Record.length&&scope.row.Record[0].Status==3" size="small" type="danger">已退回</el-tag>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" align="center" v-if="PIC==user_id">
          <template slot-scope="scope">
            <div style="display: flex;flex-flow: column nowrap;justify-content: center;align-items: center;">
                <el-button v-if="scope.row.Record.length&&scope.row.Record[0].Status==1" style='margin:2px' size="mini" type="success" @click="approve(scope.row)">同意</el-button>
                <el-button v-if="scope.row.Record.length&&scope.row.Record[0].Status==1" style='margin:2px' size="mini" type="danger" @click="returnToModify(scope.row)">退回</el-button>
                <el-button v-if="scope.row.Record.length&&scope.row.Record[0].Status==2" style='margin:2px' size="mini" type="danger" @click="cancelApprove(scope.row)">撤回</el-button>
             </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination class="pagination" :page='pageSetting.page' @pagination='pagination' :total='pageSetting.total' :limit='pageSetting.limit'></pagination>
      </el-card>
    </el-col>
    </el-row>
  </div>
</template>
<script>
import http from '@/http'
import searcherDialog from './Searcher/index.js'
import Store from '@/store'
import dateformat from 'dateformat'
export default {
  props:['demandId','PIC'],
  data() {
    return {
      items:[],
      supplierList:[],
      customerACL:[],
      visible:false,
      isSearching:false,
      user_id:Store.state.user_id,
      customerId:Store.state.item_content._id,
      pageSetting:{
        total:20,
        page:1,
        limit:20,
      }
    }
  },
  methods:{
    async fetch(){
      const res=await http.get(`/crm/demandDetail/demandId/${this.demandId}`,{
          params: this.pageSetting
      });
      this.pageSetting.total=res.data.total
      this.items=res.data.items
    },
    approve(row){
      row.Record.unshift({
        Operator:Store.state.user_id,
        Status:2,
        Action:'approve'
      })
      this.saveRow(row)
      this.$message({
        type: "info",
        message: '审核同意',
      });
      // this.fetch()
    },
    cancelApprove(row){
      row.Record.unshift({
        Operator:Store.state.user_id,
        Status:1,
        Action:'cancelApprove'
      })
      this.saveRow(row)
      this.$message({
        type: "info",
        message: '撤回重审',
      });
      // this.fetch()
    },
    returnToModify(row){
      this.$prompt('请输入审核退回意见', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(async({ value }) => {
          row.Record.unshift({
            Operator:Store.state.user_id,
            Status:3,
            Action:'returnToModify',
            Comment:value
          })
          this.saveRow(row)
          this.$message({
            type: "info",
            message: '已审核退回',
          });
          // this.fetch()
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消退回'
          });
        });
    },
    async fetchSupplier(){
      const res=await http.get('/srm/supplier');
      this.supplierList=res.data
    },
    calcSupplier(supplierId){
      if(supplierId){
        const supplier=this.supplierList.find(item=>item._id==supplierId)
        return supplier.name        
      }
    },
    calcDate(date){
      return dateformat(date,"yyyy-mm-dd")
    },
    pagination(data){
      this.pageSetting.page=data.page
      this.pageSetting.limit=data.limit
      this.fetch()
    },
    async saveRow(row){
      await http.put(`/crm/demandDetail/id/${row._id}`,row);
    },
    openSearcher(){
      searcherDialog(this.supplierList,this.demandId,this.customerACL,this.handleSearch)
    },
    cancelSearch(){
      this.isSearching=false
      this.pageSetting={
        total:20,
        page:1,
        limit:20,
      },
      this.fetch()
    },
    handleSearch(data){
      this.items=data
      this.pageSetting.total=this.items.length
      this.pageSetting.limit=this.items.length
      this.isSearching=true
    },
    calcQuantity(row, column, cellValue, index){
      return row.Quantity+row.Unit
    },
    calcPIC(row, column, cellValue, index){
      const pic=this.customerACL.find(item=>item._id==row.PIC)
      if(pic){
        return pic.nickname        
      }
    },
    async getCustomerACL() {
        const res=await http.get(`/crm/customer/customerACL/${this.customerId}`)
        this.customerACL = res.data
    },
  },
  created(){
    this.fetchSupplier()
    this.getCustomerACL() 
  }
};
</script>
<style scoped>
.inquiry>>>.el-upload{
  display:contents;
}
#tableCard >>>.el-table .cell{
  line-height: 1.3!important;
  padding: 0;
}
/*鼠标移入某行时的背景色*/
#tableCard >>>.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #fad8bca4!important;
}
#tableCard >>>.el-table__body tr.current-row > td {
  background-color: #c6e4f8b4 !important;
}
.el-table .cell p{
  margin: 0!important;
}
.icon-search{
  font-size: 22px;
  position:fixed;
  top: 10px;
  right: 15px;
  cursor: pointer;
  z-index:1000;
}
.icon-confirm{
  font-size: 20px;
  cursor: pointer;
}
.icon-cancel{
  font-size: 24px;
  cursor: pointer;
}
.item-selected{
  height: 30px;
  line-height: 30px;
  color:rgba(26, 155, 0, 0.777);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.item-not-selected{
  color:rgb(157, 157, 157);
  height: 30px;
  line-height: 30px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered {
  margin-left: 0;
}
</style>
